export default __webpack_public_path__ + "static/media/3-3-1.2d9e7476.jpg";